export const UserActionTypes = {
    SET_CURRENT_USER: 'SET_CURRENT_USER',
    GET_LINK_DATA: 'GET_LINK_DATA',
};
